
const style = {
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'pointer',
    width: '100%'
}
export const DistanceComponent = ({ distance }) => {

    return (
        <div style={{ ...style }}>
            <div className="w-full text-l font-bold">{distance.distance} - {distance.duration}</div>
        </div>
    )
}
